import { c as _c } from "react/compiler-runtime";
import { LabelWithHelp } from "@components/common/label-with-help";
import { ExternalLinks } from "@components/external-links";
import { FontWeights, SingleSelectAutocomplete } from "@flat-ui";
import { formatUserRoleType, userRoleDescription } from "@utils/data-display";
import { useMemo } from "react";
export function RoleAutocomplete(t0) {
  const $ = _c(29);
  const {
    selectedRole,
    onChange,
    onResetSelection,
    placeholder: t1,
    roles,
    disabledRoles: t2,
    link,
    labelTitle,
    isRequired: t3,
    dataTestId
  } = t0;
  const placeholder = t1 === undefined ? "Select a role..." : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const disabledRoles = t4;
  const isRequired = t3 === undefined ? false : t3;
  let t5;
  if ($[2] !== roles) {
    t5 = roles.map(_temp);
    $[2] = roles;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const roleOptions = t5;
  let t6;
  if ($[4] !== roleOptions || $[5] !== selectedRole) {
    t6 = roleOptions.find(option => option.value === selectedRole) ?? null;
    $[4] = roleOptions;
    $[5] = selectedRole;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const selectedValue = t6;
  let t7;
  if ($[7] !== onChange || $[8] !== onResetSelection) {
    t7 = function onSelectedRoleChanged(newValue) {
      if (newValue && typeof newValue === "object") {
        onChange(newValue.value);
      } else {
        if (onResetSelection) {
          onResetSelection();
        }
      }
    };
    $[7] = onChange;
    $[8] = onResetSelection;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const onSelectedRoleChanged = t7;
  let t8;
  if ($[10] !== isRequired || $[11] !== labelTitle) {
    t8 = labelTitle && <LabelWithHelp title={labelTitle} isRequired={isRequired} />;
    $[10] = isRequired;
    $[11] = labelTitle;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = !isRequired;
  let t10;
  if ($[13] !== disabledRoles) {
    t10 = option_0 => disabledRoles.includes(option_0.value);
    $[13] = disabledRoles;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== link) {
    t11 = link ? <ExternalLinks link={link} text="Learn about permissions levels" sx={{
      display: "flex",
      alignItems: "flex-start",
      fontSize: "11px",
      fontWeight: FontWeights.SemiBold,
      gap: "12px",
      padding: "8px",
      flex: "1 0 0",
      color: "primary.main"
    }} /> : undefined;
    $[15] = link;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== dataTestId || $[18] !== onSelectedRoleChanged || $[19] !== placeholder || $[20] !== roleOptions || $[21] !== selectedValue || $[22] !== t10 || $[23] !== t11 || $[24] !== t9) {
    t12 = <SingleSelectAutocomplete showIcon={false} isReadOnlyInput={true} showSelectedCheckmark={true} placeholder={placeholder} value={selectedValue} options={roleOptions} dataTestId={dataTestId} isClearable={t9} onChange={onSelectedRoleChanged} getOptionDisabled={t10} paperFooter={t11} />;
    $[17] = dataTestId;
    $[18] = onSelectedRoleChanged;
    $[19] = placeholder;
    $[20] = roleOptions;
    $[21] = selectedValue;
    $[22] = t10;
    $[23] = t11;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12 || $[27] !== t8) {
    t13 = <>{t8}{t12}</>;
    $[26] = t12;
    $[27] = t8;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}
function _temp(role) {
  return {
    title: formatUserRoleType(role),
    subtitle: userRoleDescription(role),
    value: role
  };
}